/**
 * Admin — Variants Routes
 *
 * Routes:
 * - /admin/evaluations/:evaluationId/variants/new             → 'admin-evaluation-variant-form'
 * - /admin/evaluations/:evaluationId/variants/:variantId/edit → 'admin-evaluation-variant-form'
 */

import { Outlet, type RouteObject } from 'react-router-dom';
import { CONTEXTS } from '@/app/registry';

export const adminVariantsRoutes: RouteObject[] = [
  {
    path: 'admin/evaluations/:evaluationId/variants/new',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_EVALUATION_VARIANT_FORM, title: 'Nouvelle variante' },
  },
  {
    path: 'admin/evaluations/:evaluationId/variants/:variantId/edit',
    Component: Outlet,
    handle: { context: CONTEXTS.ADMIN_EVALUATION_VARIANT_FORM, title: 'Modifier la variante' },
  },
];
